import { BaseEditViewStore } from 'core/stores';
import { FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalForm } from 'application/facility-order-new-flow-us-intake/forms';
import { FacilityOrderPatientService } from "application/facility-order-new-flow-insurance/services";
import { action, observable } from "mobx";

class FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalStore extends BaseEditViewStore {
    @observable accessor disabled = false;
    constructor(rootStore, componentProps) {
        const facilityOrderPatientService = new FacilityOrderPatientService(rootStore.application.baasic.apiClient);
        const facilityOrderPatient = componentProps.modalParams.data.facilityOrderPatient;
        super(rootStore, {
            name: 'facility-order-template-us-intake-add-insurance-question-modal',
            Form: FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalForm,
            id: facilityOrderPatient.id,
            actions: () => {
                return {
                    get: async () => {
                        return facilityOrderPatient;
                    },
                    update: async (resource) => {
                        const response = await facilityOrderPatientService.updateInsuranceQuestion({ ...resource });
                        return response.data;
                    },
                }
            },
            FormClass: FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderPatient = facilityOrderPatient;
        this.facilityOrderPatientService = facilityOrderPatientService;
        this.showTemplateChangeWarning = this.modalParams.data.showTemplateChangeWarning;
    }

    @action.bound
    async resolveInsuranceQuestion() {
        this.disabled = true;
        await this.facilityOrderPatientService.resolveInsuranceQuestion({ id: this.facilityOrderPatient.id });
        this.facilityOrderPatient.isInsuranceQuestion = true;
        this.facilityOrderPatient.insuranceQuestion = null;
        this.disabled = false;
        this.modalParams.close();

        if(this.showTemplateChangeWarning)
            this.showTemplateChangeWarning();
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            if (resource.insuranceQuestion === null || resource.insuranceQuestion === undefined || resource.insuranceQuestion === '') {
                await this.resolveInsuranceQuestion();
            }
            else {
                await this.facilityOrderPatientService.updateInsuranceQuestion({
                    id: this.id,
                    ...resource
                });

                this.facilityOrderPatient.insuranceQuestion = resource.insuranceQuestion;
                this.form.setFieldsDisabled(false);
                this.modalParams.close();
            }
            if(this.showTemplateChangeWarning)
                this.showTemplateChangeWarning();
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalStore;
